export default "/images/23b81cbb7a582bc2e9210911f92287e8.avif";